"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var Ajax = /*#__PURE__*/function () {
  function Ajax() {
    (0, _classCallCheck2.default)(this, Ajax);
  }

  (0, _createClass2.default)(Ajax, [{
    key: "generateCallbackFunction",
    value: function generateCallbackFunction() {
      return "jsonp_" + Date.now() + "_" + Math.ceil(Math.random() * 100000);
    }
  }, {
    key: "httpRequest",
    value: function httpRequest() {
      return new XMLHttpRequest();
    }
  }, {
    key: "jsonp",
    value: function jsonp(url, callback) {
      var callbackFunction = this.generateCallbackFunction();

      window[callbackFunction] = function (data) {
        callback(data);
      };

      var src = "" + url + (url.indexOf('?') !== -1 ? '&' : '?') + "callback=" + callbackFunction;
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = src;
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }, {
    key: "send",
    value: function send(url, callback, method) {
      var httpRequest = this.httpRequest();
      httpRequest.open(method, url);

      httpRequest.onreadystatechange = function () {
        if (httpRequest.readyState === 4 && httpRequest.status === 200) {
          try {
            var data = JSON.parse(httpRequest.responseText);
            callback(data);
          } catch (error) {
            console.log(error.message + " in " + httpRequest.responseText);
            return;
          }
        }
      };

      httpRequest.send();
    }
  }, {
    key: "get",
    value: function get(url, callback) {
      this.send(url, callback, 'GET');
    }
  }]);
  return Ajax;
}();

var _default = new Ajax();

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/Ajax.js
// module id = 3
// module chunks = 1 2 3